/***
 * This is a file holding functions which will be imported by other applications to handle common actions
 * In particular, this will handle input validation on various forms.
 *
 */

/**
 * The attribute isn't ready for saving unless something has changed.  
 * @param {String} stateVar 
 * @param {String} propsVar 
 * @param {Boolean} allowEmptyString if true, empty strings don't disable.
 * @returns {Boolean} false means something has changed (don't disable).
 */
export function disableAttributeCheck(stateVar, propsVar, allowEmptyString) {
  if (stateVar !== null) {
    if (propsVar === null && stateVar === '')
      return true;

    if ((propsVar !== null && propsVar !== '') && stateVar === '') {
      if (allowEmptyString) {
        return false;
      } else {
        return true;
      }
    }

    if (propsVar !== stateVar)
      return false;
  }
  return true;
}

/**
 * Convert numeric value to USD currency string or empty string if not a number.
 * @param {Number} theValue currency value in numeric form
 * @returns String of the currency amount in USD format to the hundredths place
 */
export function getCurrencyString(theValue) {
  if (isNaN(theValue))
    return '';

  let currencyString = Number(theValue)
      .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

  return currencyString;
};

/**
 * Determine the value to display for render based on passed arguments (usually state, prop, and a default value).
 * 
 * @param  {...any} args 
 * @returns 
 */
export function getValueForRender(...args) {
  for (let i = 0; i < args.length; i++) {
    if (args[i] != null) {
      return args[i];
    }
  }
  return null;
}

/**
 * Determine the value to display for render based on passed arguments (usually state, prop, and a default value).
 * Return as a number (or null if not a number).
 * 
 * @param  {...any} args 
 * @returns 
 */
export function getNumericValueForRender(...args) {
  for (let i = 0; i < args.length; i++) {
    if (args[i] != null) {
      return Number(args[i]);
    }
  }
  return null;
}

/**
 * Determine the value to display for render based on passed arguments (usually state, prop, and a default value).
 * Return as a number (or null if not a number).
 * 
 * @param  {...any} args 
 * @returns 
 */
export function getNumericNonZeroValueForRender(...args) {
  for (let i = 0; i < args.length; i++) {
    if (args[i] != null && Number(args[i]) !== 0) {
      return Number(args[i]);
    }
  }
  return null;
}

/**
 * Evaluate if a string is a valid URL (see https://regexr.com/37i6s for regex pattern)
 * @param {String} stateVar string to verify is url
 * @returns {String} empty string if valid, message error if invalid.
 */
export function isValidURL (stateVar) {
  if (stateVar !== null && stateVar !== '') {
     var re = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/); 
     if (re.test(stateVar)) {
        return '';
      } else {
        return 'Field, if specified, must be a valid URL';
      }
  } else {
    return '';
  }
}

/**
 * Evaluate a day number and return its equivalent text
 */
export function getDayLabel(dayOfMonth) {
  let dayText = ''
  if (dayOfMonth === 1) { dayText = '1st'; }
  if (dayOfMonth === 2) { dayText = '2nd'; }
  if (dayOfMonth === 3) { dayText = '3rd'; }
  if (dayOfMonth > 3 && dayOfMonth < 21) {
    dayText = dayOfMonth + 'th';
  }
  if (dayOfMonth === 21) { dayText = '21st'; }
  if (dayOfMonth === 22) { dayText = '22nd'; }
  if (dayOfMonth === 23) { dayText = '23rd'; }
  if (dayOfMonth > 23 && dayOfMonth < 31) {
    dayText = dayOfMonth + 'th';
  }
  if (dayOfMonth === 31) { dayText = '31st'; }

  return dayText;
}